import React, { useEffect, useState } from 'react'
import { apiFetch } from '../../lib/api-client'

interface KontokortEntry {
  id: string
  entry_date: string
  description: string | null
  invoice_number: string | null
  debit_oere: number
  credit_oere: number
  saldo_oere: number
}

interface Kontokort {
  lease_id: string
  current_saldo_oere: number
  entries: KontokortEntry[]
}

function kr(oere: number): string {
  return (oere / 100).toLocaleString('da-DK', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' kr.'
}

const th: React.CSSProperties = { padding: '10px 20px', fontSize: 11, fontWeight: 600, color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.04em', textAlign: 'left' }
const td: React.CSSProperties = { padding: '11px 20px', fontSize: 13, color: '#111827', borderTop: '1px solid #f3f4f6' }
const num: React.CSSProperties = { textAlign: 'right', fontVariantNumeric: 'tabular-nums' }

export function KontokortTab({ leaseId }: { leaseId: string }) {
  const [data, setData] = useState<Kontokort | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    apiFetch<Kontokort>(`/api/v1/ledger/kontokort/${leaseId}`).then(setData).catch(() => {}).finally(() => setLoading(false))
  }, [leaseId])

  if (loading) return <div style={{ padding: 40, textAlign: 'center', color: '#9ca3af', fontSize: 13 }}>Henter…</div>

  const saldo = data?.current_saldo_oere ?? 0

  return (
    <div style={{ background: '#fff', border: '1px solid #e8eaed', borderRadius: 10, overflow: 'hidden' }}>
      <div style={{ padding: '14px 20px', borderBottom: '1px solid #e8eaed', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span style={{ fontSize: 11, fontWeight: 700, color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.06em' }}>Bevægelser</span>
        <span style={{ fontSize: 13, color: '#6b7280' }}>
          Aktuel saldo:{' '}
          <strong style={{ color: saldo > 0 ? '#b91c1c' : '#15803d', fontVariantNumeric: 'tabular-nums' }}>{kr(saldo)}</strong>
        </span>
      </div>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr style={{ background: '#f8fafc' }}>
            <th style={th}>Dato</th>
            <th style={th}>Bilag</th>
            <th style={th}>Beskrivelse</th>
            <th style={{ ...th, ...num }}>Debet</th>
            <th style={{ ...th, ...num }}>Kredit</th>
            <th style={{ ...th, ...num }}>Saldo</th>
          </tr>
        </thead>
        <tbody>
          {(data?.entries ?? []).map((e) => (
            <tr key={e.id}>
              <td style={td}>{e.entry_date}</td>
              <td style={td}>{e.invoice_number ?? '—'}</td>
              <td style={{ ...td, color: '#6b7280' }}>{e.description ?? '—'}</td>
              <td style={{ ...td, ...num }}>{e.debit_oere ? kr(e.debit_oere) : '—'}</td>
              <td style={{ ...td, ...num }}>{e.credit_oere ? kr(e.credit_oere) : '—'}</td>
              <td style={{ ...td, ...num, fontWeight: 600 }}>{kr(e.saldo_oere)}</td>
            </tr>
          ))}
          {(data?.entries.length ?? 0) === 0 && (
            <tr><td style={{ ...td, color: '#9ca3af' }} colSpan={6}>Ingen bevægelser endnu. Posteringer dannes når der opkræves eller registreres betaling.</td></tr>
          )}
        </tbody>
      </table>
    </div>
  )
}
